import {
  FETCH_UI_CONFIG,
  FETCH_UI_CONFIG_FAILURE,
  FETCH_UI_CONFIG_SUCCESS,
  RESET_UI_CONFIG,
} from "./uiConfigTypes";
export const fetchingState = {
  inProgress: "inProgress",
  success: "Success",
  failure: "Failure",
};
const initialState = {
  config: undefined,
  fetchingStatus: {
    state: false,
  },
  error: undefined,
};

const uiConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_UI_CONFIG:
      return {
        ...state,
        fetchingStatus: {
          state: fetchingState.inProgress,
        },
      };
    case FETCH_UI_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingStatus: { state: fetchingState.success },
        config: action.payload,
      };
    case FETCH_UI_CONFIG_FAILURE:
      return {
        ...state,
        fetchingStatus: {
          state: fetchingState.failure,
        },
        config: undefined,
        error: action.payload,
      };
    case RESET_UI_CONFIG: {
      return {
        ...initialState,
      };
    }
    default:
      return {
        ...state,
      };
  }
};

export default uiConfigReducer;
